import React from 'react';

export default function SVGInfo(): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      fill="#none"
      className="text-iconStrong fill-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13 9h-2V7h2m0 10h-2v-6h2m-1-9A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2Z" />
    </svg>
  );
}
